import { cn } from '@/lib/utils';
import { useContentPlays } from '@/lib/hooks/use-content-plays';
import { SectionBackground } from '@/components/ui/section-background';
import { useProfile } from '@/lib/providers';

type Day = {
  name: string;
  date: number;
  isActive?: boolean;
};

const DAY_NAMES = ['ZO', 'MA', 'DI', 'WO', 'DO', 'VR', 'ZA'];

export function ActivityCalendar() {
  const { profile } = useProfile();
  const currentDate = new Date();

  // Get the current week's days
  const days: Day[] = [];
  const firstDayOfWeek = new Date(currentDate);
  firstDayOfWeek.setDate(currentDate.getDate() - currentDate.getDay());

  const { contentPlays } = useContentPlays(
    profile ? { userId: profile.id } : { disabled: true },
  );
  const activityDates = contentPlays.activityDates;

  for (let i = 0; i < 7; i++) {
    const date = new Date(firstDayOfWeek);
    date.setDate(firstDayOfWeek.getDate() + i);
    days.push({
      name: DAY_NAMES[i],
      date: date.getDate(),
      isActive: activityDates.some(
        (activityDate) =>
          activityDate.getDate() === date.getDate() &&
          activityDate.getMonth() === date.getMonth() &&
          activityDate.getFullYear() === date.getFullYear(),
      ),
    });
  }

  return (
    <SectionBackground className="w-full max-w-2xl mx-auto bg-white p-4">
      <h3 className="text-lg font-medium mb-4">Deze week:</h3>
      <div className="flex justify-between gap-2">
        {days.map((day, index) => (
          <div
            key={index}
            className={cn(
              'flex-1 aspect-square flex flex-col items-center justify-center text-sm',
              currentDate.getDay() === index && 'bg-muted rounded-lg',
            )}
          >
            {day.isActive ? (
              <div className="w-12 h-12 flex flex-col items-center">
                <div className="text-xs text-muted-foreground mb-1">
                  {day.name}
                </div>
                <div className="w-8 h-8 rounded-full bg-[#00A67E] flex items-center justify-center text-white text-sm">
                  {day.date}
                </div>
              </div>
            ) : (
              <>
                <div className="text-xs text-muted-foreground">{day.name}</div>
                <div className="text-sm">{day.date}</div>
              </>
            )}
          </div>
        ))}
      </div>
    </SectionBackground>
  );
}
